import { DeleteOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Button, Divider } from 'antd';
import SafeImage from 'components/SafeImage';
import { isStoreAliasFirst, useStoreNameConfig } from 'hooks/business/store/useStoreName';
import { useGetRegionLabel } from 'hooks/business/useRegion';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';

function SelectResult({
  itemMap,
  value,
  onDeselect,
}: {
  itemMap: Partial<Record<string, ReviewAnalysis.Item>>;
  value: string[];
  onDeselect: (items: string[]) => void;
}) {
  const { t } = useTranslate();
  const getRegionLabel = useGetRegionLabel();

  const { config } = useStoreNameConfig();

  return (
    <Container>
      <header>
        <div>
          {t('已选')} SPU({value.length})
        </div>
        {value.length > 0 && (
          <Button type="link" onClick={() => onDeselect(value)}>
            {t('清空')}
          </Button>
        )}
      </header>
      <ul>
        {value.map((id) => {
          const item = itemMap[id];
          if (!item) {
            return null;
          }
          const { spuId, img, name, platform, region, storeName, storeAlias, itemSku } = item;
          const storeAliasFirst = isStoreAliasFirst(config, platform, region);
          return (
            <li key={id}>
              <SafeImage width={60} height={60} src={img} />
              <section>
                <div>{name}</div>
                <p>
                  {t('店铺')}：{platformLabelMap[toLowerCase(platform)]}-{getRegionLabel(region)}-
                  {storeAliasFirst ? storeAlias || storeName : storeName}
                </p>
                <p>
                  ID：
                  {spuId}
                  <Divider type="vertical" />
                  {t('主商品货号')}：{itemSku}
                </p>
              </section>
              <Button type="text" icon={<DeleteOutlined />} onClick={() => onDeselect([id])} />
            </li>
          );
        })}
      </ul>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  > header {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 12px;
    > div {
      position: relative;
      text-indent: 12px;
      font-weight: 500;
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 2;
        left: 0;
        width: 4px;
        height: 12px;
        background: var(--ant-primary-color);
      }
    }
  }
  > ul {
    flex: 1 0 0;
    padding: 0 12px;
    overflow: auto;
    > li {
      display: flex;
      margin-bottom: 16px;
      padding: 8px 12px;
      border: solid 1px #d3d7e0;
      background: #fff;
      > div {
        flex: 0 0 auto;
        margin-right: 8px;
      }
      > section {
        flex: 1 0 0;
        overflow: hidden;
        > div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        > p {
          margin-bottom: 0;
          font-size: 12px;
          color: #84868c;
        }
      }
    }
  }
`;

export default SelectResult;
